const WarningArea = ({ type = 'info', message }) => {
    const styles = {
        info: {
            container: "bg-blue-50 dark:bg-blue-900 border border-blue-200 dark:border-blue-700",
            icon: "pi pi-info-circle text-blue-500",
            title: "Bilgilendirme",
            titleColor: "text-blue-700 dark:text-blue-300",
            textColor: "text-blue-600 dark:text-blue-400"
        },
        warning: {
            container: "bg-red-50 dark:bg-red-900 border border-red-200 dark:border-red-700",
            icon: "pi pi-exclamation-triangle text-red-500",
            title: "Önemli Uyarı",
            titleColor: "text-red-700 dark:text-red-300",
            textColor: "text-red-600 dark:text-red-400"
        }
    };

    const current = styles[type] || styles.info;

    return (
        <div className={`${current.container} p-4 rounded-lg`}>
            <div className="flex items-start">
                <i className={`${current.icon} text-xl mr-3 mt-1`}></i>
                <div>
                    <h4 className={`font-bold mb-2 ${current.titleColor}`}>{current.title}</h4>
                    <p className={`text-sm ${current.textColor}`}>{message}</p>
                </div>
            </div>
        </div>
    );
};

export default WarningArea;
